import { Middleware } from '@nuxt/types';

const redirects: Middleware = async (context) => {
  const { route, app } = context;

  if (!process.client) {
    return;
  }

  if (route.path === '/veidai/eurovizija/') {
    app.router?.replace('/eurovizija');

    return;
  }
};

export default redirects;
